import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const CLICK_TO_IDENTIFY_EVENT_NAMES = {
  IDENTIFY_FEATURE: 'click_to_identify_feature',
} as const;

export type IdentifyOutcome = 'hit' | 'miss';

export const trackClickToIdentifyFeature = ({
  layerName,
  featureType,
  featureCount,
  activeLayerCount,
  outcome,
}: {
  layerName: string;
  featureType: string;
  featureCount: number;
  activeLayerCount: number;
  outcome: IdentifyOutcome;
}): void => {
  gspx.trackEvent({
    name: CLICK_TO_IDENTIFY_EVENT_NAMES.IDENTIFY_FEATURE,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.GIS,
    capability: GPX_CAPABILITIES.GIS,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      feature_type: featureType,
      feature_count: featureCount,
      active_layer_count: activeLayerCount,
      outcome,
    },
    entities: {
      layer_name: layerName,
    },
  });
};
